import { render, staticRenderFns } from "./MusicalQuote.vue?vue&type=template&id=08a35a34&"
import script from "./MusicalQuote.vue?vue&type=script&lang=js&"
export * from "./MusicalQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports